import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.748,7.019,6.248.738a1.425,1.425,0,0,0-2.495,0L.251,7.024A2.008,2.008,0,0,0,2.01,10H7.988a2.01,2.01,0,0,0,1.76-2.981ZM4.5,3a.5.5,0,0,1,1,0V5a.5.5,0,0,1-1,0ZM5,8.5a1,1,0,1,1,1-1A1,1,0,0,1,5,8.5Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }